import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertNotificationService } from '../../../../services/alert-notification.service';

import { CustomerService } from '../../../../services/api/customer.service';
import { CustomersUploadDocumentsComponent } from '../../components/customers-upload-documents/customers-upload-documents.component';
import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

@Component({
  selector: 'customers-documents-for-new-clients',
  imports: [CustomersUploadDocumentsComponent],
  templateUrl: './customers-documents-for-new-clients.component.html',
  styleUrl: './customers-documents-for-new-clients.component.scss'
})
export class CustomersDocumentsForNewClientsComponent implements OnInit, OnChanges {
  @Input() documents: any;
  @Input() readonlyCustomersDocumentsForNewClients!: boolean;
  selectedFile: File | null = null;
  fileDeleted: any;

  languageOptions = [
    { key: 'eng', value: 'English' },
    { key: 'ita', value: 'Italian' },
    { key: 'spa', value: 'Spanish' }
  ];


  constructor(
    private alertNotificationService: AlertNotificationService,
    private customersService: CustomerService,
    private confirmationDialogService: ConfirmationDialogService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    
  }

   loadData() {
    this.customersService.listDocuments().subscribe((response: any) => {      
      this.documents = response.data?.customerDocuments;
      if (this.documents) {
        this.documents = {
          standard: response.data?.customerDocuments.filter((doc: any) => doc.type === 'STANDARD') || [],
          extra: response.data?.customerDocuments.filter((doc: any) => doc.type == 'EXTRA') || []
        };
      }
    });

  }

  confirmDelete(file: any) {
    this.fileDeleted = file;
    this.confirmationDialogService.open(
      `Are you confident in your decision to delete this ${file.name}?`,
      () => this.deleteFile()
    );
  }

  deleteFile(): void {
    this.documents.standard = this.documents.standard.filter((doc: any) => doc !== this.fileDeleted);
    this.fileDeleted = null;
    this.alertNotificationService.success('File deleted successfully');
  }

  addFile(file: File): void {
    if (file) {
      const newFile = { documentName: file.name, url: `assets/pdfs/${file.name}`, size: file.size };
      this.documents.standard.push(newFile);
      this.alertNotificationService.success('File added successfully');
    } else {
      console.log('No file provided');
    }
  }

  saveDocuments() {
    console.log('Save documents clicked');
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      this.addFile(selectedFile);
      input.value = '';
    }
  }

  handleDocumentsChanged(event:boolean) {
   if (event === true) {     
    this.loadData();
    }
  }
}
